import React from 'react';
import { Card } from '@totalsoft/rocket-ui';
import { FakeText } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import EvaluatedAttributeListComponent from './EvaluatedAttributeListComponent';
import PropTypes from 'prop-types';
import { Pagination } from '@totalsoft/rocket-ui';
import EvaluatedAttributeFilterComponent from './EvaluatedAttributeFilterComponent';
import { DoneOutline } from '@mui/icons-material';
import { Save } from '@mui/icons-material';
import { Add, Delete } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

const EvaluatedAttributeListContainer = ({
  onSave,
  evaluatedAttributes,
  containerDispatcher,
  isReadOnly,
  loading,
  engineAttributeOptions
}) => {
  const { t } = useTranslation();

  const onRowsPerPageChange = pageSize => {
    containerDispatcher({ type: 'UpdatePageEvaluatedAttributes', pageSize: pageSize, page: 0 });
  };

  const onPageChange = page => {
    containerDispatcher({
      type: 'UpdatePageEvaluatedAttributes',
      pageSize: evaluatedAttributes.pageSize,
      page: page
    });
  };

  const onAddAllAttributesForEvaluation = () => {
    containerDispatcher({
      type: 'OnAddAllAttributesForEvaluation',
      allEngineAttributeOptions: engineAttributeOptions
    });
  };

  const onDeleteAllEvaluatedAttributes = () => {
    containerDispatcher({
      type: 'OnDeleteAllEvaluatedAttributes'
    });
  };

  const onSaveEvaluatedAttributes = () => {
    onSave('OnSaveEvaluatedAttributes', {});
  };

  return (
    <Card
      icon={DoneOutline}
      iconColor='primary'
      title={t('EngineScoring.EvaluatedAttributes.Title')}
      actions={
        <>
          {!evaluatedAttributes.useAllAttributes && (
            <Tooltip title={t('EngineScoring.EvaluatedAttributes.AddAllAttributes')}>
              <span>
                <IconButton color='primary' onClick={onAddAllAttributesForEvaluation} disabled={isReadOnly || evaluatedAttributes.saving}>
                  <Add />
                </IconButton>
              </span>
            </Tooltip>
          )}
          {!evaluatedAttributes.useAllAttributes && (
            <Tooltip title={t('EngineScoring.EvaluatedAttributes.DeleteAllAttributes')}>
              <span>
                <IconButton color='primary' onClick={onDeleteAllEvaluatedAttributes} disabled={isReadOnly || evaluatedAttributes.saving}>
                  <Delete />
                </IconButton>
              </span>
            </Tooltip>
          )}
          <Tooltip title={t('SaveChanges')}>
            <span>
              <IconButton
                color='primary'
                onClick={onSaveEvaluatedAttributes}
                disabled={isReadOnly || !evaluatedAttributes.changed || evaluatedAttributes.saving}
              >
                <Save />
              </IconButton>
            </span>
          </Tooltip>
        </>
      }
    >
      {loading ? (
        <FakeText lines={10} />
      ) : (
        <>
          <EvaluatedAttributeFilterComponent
            engineAttributeOptions={engineAttributeOptions.filter(x =>
              evaluatedAttributes.allAttributes.every(y => x.engineAttributeId !== y.engineAttributeId)
            )}
            dispatch={containerDispatcher}
            useAllAttributes={evaluatedAttributes.useAllAttributes}
            isReadOnly={isReadOnly}
          />
          {!evaluatedAttributes.useAllAttributes && (
            <>
              <EvaluatedAttributeListComponent
                attributes={evaluatedAttributes.pagination}
                dispatch={containerDispatcher}
                isReadOnly={isReadOnly}
              />
              <Pagination
                loading={loading}
                count={evaluatedAttributes.totalCount}
                pageSize={evaluatedAttributes.pageSize}
                page={evaluatedAttributes.page}
                onRowsPerPageChange={onRowsPerPageChange}
                onPageChange={onPageChange}
                onRefresh={() => {}}
                isReadOnly={isReadOnly}
              />
            </>
          )}
        </>
      )}
    </Card>
  );
};

EvaluatedAttributeListContainer.propTypes = {
  onSave: PropTypes.func.isRequired,
  evaluatedAttributes: PropTypes.object.isRequired,
  containerDispatcher: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  loading: PropTypes.bool,
  engineAttributeOptions: PropTypes.array.isRequired
};
export default EvaluatedAttributeListContainer;
